import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { shadowStyle } from '../../comps/DropdownNew/styles'

export const style = (respPadding: number, isMobile: boolean) => ({
  normalText: {
    color: 'BLACK_21',
    fontSize: isMobile ? 14 : 18,
    lineHeight: isMobile ? 20 : 28,
    fontFamily: 'jiotype-medium',
  } as TextNewProps,
  blueBoldText: {
    color: 'BLUE_SHADE_PRIMARY',
    fontFamily: 'jiotype-medium',
    fontSize: isMobile ? 14 : 18,
    numberOfLines: 1,
    lineHeight: isMobile ? 20 : 28,
  } as TextNewProps,
  mainContainer: {
    flexDirection: isMobile ? 'column' : 'row',
    justify: 'flex-start',
    ph: !isMobile ? '5%' : 20,
    borderRadius: 12,
    pb: isMobile ? 20 : 0,
    ...shadowStyle,
    bg: '#0070B614' as ColorOptions,
  } as BoxProps,
  superView: {
    ph: respPadding,
  } as BoxProps,
  imgStyle: {
    width: 110,
    height: '100%',
    overflow: 'hidden',
  },
  underlayTrans: {
    underlayColor: 'TRANSPARENT',
    alignSelf: isMobile ? 'flex-start' : 'center',
    mt: isMobile ? 18 : 0,
    borderRadius: 6,
    height: 32,
    overflow: 'hidden',
  } as BoxProps,
  jioBizImageContainer: {
    justifyContent: 'flex-start',
    top: -40,
  } as BoxProps,
  textContainer: {
    align: 'center',
    flexDirection: 'row',
    ml: isMobile ? 0 : '7%',
    top: isMobile ? -10 : 0,
    width: !isMobile ? '62%' : '99%',
  } as BoxProps,
  textAndIcon: {
    flex: isMobile ? undefined : 1,
    justifyContent: 'space-between',
    flexDirection: isMobile ? 'column' : 'row',
  } as BoxProps,
})
